import "./RiskView.scss";
import React from "react";
import classNames from "classnames";
import DynamicText from "../../../common/DynamicText";

type RiskViewProps = {
  maxRisk: number;
  currentRisk: number;
};
export default function RiskView({ maxRisk, currentRisk }: RiskViewProps) {
  const range = Array.from(
    { length: maxRisk },
    (_, index: number) => index + 1,
  );

  return (
    <div className="risk-container">
      <DynamicText
        className="fw-500"
        textKey="page.savingsprofiles.table.expandedrow.riskview"
        replaceComponent={`${currentRisk} / ${maxRisk}`}
      />
      <div className="risk-icons ml-4">
        {range.map((value) => (
          <div
            key={value}
            className={classNames("risk-icon", {
              highlighted: value <= currentRisk,
            })}
          />
        ))}
      </div>
    </div>
  );
}
